import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import moment from "moment"; // For global localisation
import '@mdi/font/css/materialdesignicons.min.css';

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
moment.locale(
  window.localStorage.getItem("language")
    ? window.localStorage.getItem("language")
    : "ru"
);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  moment,
  render: (h) => h(App),
}).$mount("#app");
